const AUTH_URL = 'https://accounts.spotify.com/authorize';
const TOKEN_URL = 'https://accounts.spotify.com/api/token';

const DEFAULT_CLIENT_ID = process.env.REACT_APP_SPOTIFY_CLIENT_ID;
const LOCAL_PKCE_VERIFIER_KEY = 'auxify.spotify.pkce.code_verifier';

function ensureClientId(clientId) {
  const id = clientId || DEFAULT_CLIENT_ID;
  if (!id) throw new Error('Missing REACT_APP_SPOTIFY_CLIENT_ID');
  return id;
}

function getCrypto() {
  if (window.crypto && window.crypto.subtle) return window.crypto;
  throw new Error('Web Crypto API not available');
}

function base64UrlEncode(bytes) {
  const bin = String.fromCharCode(...new Uint8Array(bytes));
  return btoa(bin).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}

function generateRandomString(length) {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  const values = getCrypto().getRandomValues(new Uint8Array(length));
  let result = '';
  for (let i = 0; i < values.length; i += 1) {
    result += charset[values[i] % charset.length];
  }
  return result;
}

async function sha256(input) {
  const encoder = new TextEncoder();
  const data = encoder.encode(input);
  return getCrypto().subtle.digest('SHA-256', data);
}

export async function beginSpotifyLogin({ scope, state, redirectUri, clientId }) {
  const id = ensureClientId(clientId);
  const verifier = generateRandomString(64);
  const challenge = base64UrlEncode(await sha256(verifier));
  window.localStorage.setItem(LOCAL_PKCE_VERIFIER_KEY, verifier);

  const params = new URLSearchParams({
    response_type: 'code',
    client_id: id,
    redirect_uri: redirectUri || `${window.location.origin}/queue-created`,
    code_challenge_method: 'S256',
    code_challenge: challenge,
  });
  if (scope) params.set('scope', scope);
  if (state) params.set('state', state);

  window.location.href = `${AUTH_URL}?${params.toString()}`;
}

export async function exchangeAuthCodeForToken({ code, redirectUri, clientId }) {
  const id = ensureClientId(clientId);
  const verifier = window.localStorage.getItem(LOCAL_PKCE_VERIFIER_KEY);
  if (!verifier) throw new Error('Missing PKCE code_verifier in storage');

  const body = new URLSearchParams({
    client_id: id,
    grant_type: 'authorization_code',
    code,
    redirect_uri: redirectUri || `${window.location.origin}/queue-created`,
    code_verifier: verifier,
  });
  const res = await fetch(TOKEN_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body,
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Token exchange failed (${res.status}): ${text}`);
  }
  const json = await res.json();
  try { window.localStorage.removeItem(LOCAL_PKCE_VERIFIER_KEY); } catch (e) {}
  return json;
}
